import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { styled } from "@mui/material/styles";

const EmailIconSvg = styled(SvgIcon)`
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
`;

const EmailIcon = (props) => (
  <EmailIconSvg {...props}>
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
    />
    <polyline xmlns="http://www.w3.org/2000/svg" points="22,6 12,13 2,6" />
  </EmailIconSvg>
);

export default EmailIcon;
